import { render } from "./AppPopoverWrapper.vue?vue&type=template&id=11bdd0bc&scoped=true"
const script = {}

import "./AppPopoverWrapper.vue?vue&type=style&index=0&id=11bdd0bc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11bdd0bc"]])

export default __exports__